import React from 'react';
import FieldValTypography from '../../common/FieldValTypography';
import { ArtifactSizeInfo } from './ArtifactSizeInfo';
import DownSizedBy from './DownSizedBy';

// reusable component to display fields related to artifact.
function ArtifactViewerDialogFields({ name, createdDate, size, sourceFileSize }) {
	return (
		<div>
			<FieldValTypography field="Artifact" val={name} />
			<FieldValTypography field="Date Created" val={createdDate} />
			<ArtifactSizeInfo bytes={size} />
			<DownSizedBy sourceFileSize={sourceFileSize} artifactSize={size} />
		</div>
	);
}

export default ArtifactViewerDialogFields;
